/**
 * Copied mobx-react-router into this file since its
 * no longer maintained
 */

import { BrowserHistory, Location } from "history";
import { action, computed, observable, observe } from "mobx";
import { CVPSearchParams } from "./wsQueryStringStore";

export const syncHistoryWithStore = (
  history: BrowserHistory,
  store: RouterStore
) => {
  // Initialise store
  store.history = history;

  // Handle update from history object
  const handleLocationChange = (args) => {
    store._updateLocation(args?.location || args);
  };

  const unsubscribeFromHistory = history.listen(handleLocationChange);
  handleLocationChange(history.location);

  const subscribe = (listener) => {
    const onStoreChange = () => {
      const rawLocation = { ...store._location };
      listener(rawLocation, history.action);
    };

    // Listen for changes to _location state in store
    const unsubscribeformStore = observe(store, "_location", onStoreChange);

    listener(store._location, history.action);

    return unsubscribeformStore;
  };

  // @ts-ignore
  history.subscribe = subscribe;
  // @ts-ignore
  history.unsubscribe = unsubscribeFromHistory;

  return history;
};

export class RouterStore {
  @observable _location: Location = null;
  @observable hostUrl: string = null;

  // value of unsavedChangesStrategy from current redirect
  unsavedChangesStrategy: UnsavedChangesStrategy | undefined = undefined;

  @computed get location(): Location {
    if (
      window.cvpEmbedType === "iframe" &&
      this.hostUrl &&
      !window.iframe_preventNavigationTakeover
    ) {
      const url = new URL(this.hostUrl);

      return {
        pathname: url.searchParams.get(CVPSearchParams.cvpage) ?? "",
        hash: this._location.hash,
        key: this._location.key,
        search: url.search,
        state: this._location.state,
      };
    }

    return this._location;
  }

  history: BrowserHistory = null;

  @action _updateLocation(newState) {
    this._location = newState;
  }
}

export enum UnsavedChangesStrategy {
  /** check for unsaved changes and block if any */
  check = "check",

  /** unblock, navigate and reblock */
  ignore = "ignore",

  /** unblock and navigate */
  forget = "forget",
}
